/**
 * Shared country ordering for every País selector in the app (search fields +
 * job-posting form): priority markets first, in a fixed order, then every
 * other supported country alphabetically by the name shown in the active
 * language (ES/EN/PT). To add a new priority market later, just extend
 * PRIORITY_COUNTRY_CODES — no call site needs to change.
 */
export const PRIORITY_COUNTRY_CODES = ["ES", "US"];

export function sortCountriesByPriority(countries, t) {
  const byCode = {};
  countries.forEach((c) => { byCode[c.code] = c; });
  const priority = PRIORITY_COUNTRY_CODES.map((code) => byCode[code]).filter(Boolean);
  const priorityCodes = new Set(priority.map((c) => c.code));
  const rest = countries
    .filter((c) => !priorityCodes.has(c.code))
    .sort((a, b) => t(`geo.countryNames.${a.code}`).localeCompare(t(`geo.countryNames.${b.code}`), undefined, { sensitivity: "base" }));
  return [...priority, ...rest];
}
